import { render, staticRenderFns } from "./instagram-view.vue?vue&type=template&id=037b85c4&scoped=true&"
import script from "./instagram-view.vue?vue&type=script&lang=js&"
export * from "./instagram-view.vue?vue&type=script&lang=js&"
import style0 from "./instagram-view.vue?vue&type=style&index=0&id=037b85c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037b85c4",
  null
  
)

export default component.exports